interface Scripts {
  name: string;
  src: string;
  extraParams?: any;
  shouldLoadInCheckout?: boolean;
  includeAtLoad?: boolean;
  restrictRoute?: string;
}
export const ScriptStore: Scripts[] = [
  {
    name: "osano",
    src: "https://cmp.osano.com/dkBTcxu1Pa/604ace45-6770-4043-b78e-a52ec423efb2/osano.js",
  },
  {
    name: "osano-fender-dev",
    src: "https://cmp.osano.com/dkBTcxu1Pa/6760036d-bb01-44b0-a4fb-8950a6909395/osano.js",
  },
  {
    name: "osano-fender",
    src: "https://cmp.osano.com/dkBTcxu1Pa/0b583d34-ae17-421d-bf65-642666e5babe/osano.js",
  },
  { name: "segment", src: "./assets/js/segment.js" },
  { name: "segment-dev", src: "./assets/js/segment-dev.js" },
  { name: "googletagmanager", src: "./assets/js/google-tagmanager.js", includeAtLoad: true },
  { name: "webview-interface", src: "./assets/js/webview-interface.js" },
  {
    name: "stripe",
    src: "https://js.stripe.com/v3/",
    restrictRoute: "/checkout",
  },
  {
    name: "google-maps",
    src: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBIbF61F87RCS81MKJK7iorZUgyycP1h-A&loading=async",
    extraParams: {
      async: "true",
      defer: "true",
    },
    includeAtLoad: true,
  },
  {
    name: "usercentrics-dev",
    src: "https://app.usercentrics.eu/browser-ui/latest/loader.js",
    extraParams: {
      id: "usercentrics-cmp",
      "data-version": "preview",
      "data-settings-id": "dyPcRoeeJ",
    },
  },
  {
    name: "usercentrics-prod",
    src: "https://app.usercentrics.eu/browser-ui/latest/loader.js",
    extraParams: {
      id: "usercentrics-cmp",
      "data-settings-id": "dyPcRoeeJ",
    },
  },
  {
    name: "human-dev",
    src: "https://client.px-cloud.net/PX0yHF4Wq2/main.min.js",
    extraParams: {
      async: "true",
    },
  },
  {
    name: "human-prod",
    src: "https://client.px-cloud.net/PXHAqrlzE4/main.min.js",
    extraParams: {
      async: "true",
    },
  },
  {
    name: "human-fender-prod",
    src: "https://client.px-cloud.net/PXfelYuvgJ/main.min.js",
    extraParams: {
      async: "true",
    },
  },
];
